<template>
  <div>
    <epi-modal :opening-event-name="openingEventName" title="프로그램 순서변경">
      <template v-slot:body>
        <draggable v-model="programs" group="false">
          <epi-card v-for="p in programs" :key="p" class="mb-3">
            <template v-slot:body>
              <div class="hstack gap-1">
                <i class="bi bi-three-dots-vertical pointer"></i>
                <div class="ms-4"></div>
                <input type="text" class="form-control" readonly :value="p" />
              </div>
            </template>
          </epi-card>
        </draggable>
      </template>
      <template v-slot:footer>
        <div class="hstack gap-2 justify-content-end">
          <button class="btn btn-light">취소</button>
          <button class="btn btn-light">수정</button>
        </div>
      </template>
    </epi-modal>
  </div>
</template>

<script>
import { EventName } from "@/const";
import draggable from "vuedraggable";

export default {
  name: "ProgramOrderEditModal",
  components: { draggable },
  data() {
    return {
      openingEventName: EventName.ProgramOrderEditModalOpening,
      programs: [
        "심리검사",
        "개인상담",
        "커플상담",
        "첫 상담 할인",
        "언어치료",
        "집단상담",
      ],
    };
  },
};
</script>
